import { render, staticRenderFns } from "./EmailComposes.vue?vue&type=template&id=0baae3fc"
import script from "./EmailComposes.vue?vue&type=script&lang=js"
export * from "./EmailComposes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports